<template>
  <v-textarea
      v-model="message.body"
      auto-grow
      outlined
      placeholder="Type message here..."
      dense
      hide-details
      full-width
      :rows="rows"
      class="mb-0 compose-message__textarea"
      :disabled="loading"
      @keydown.ctrl.enter="send()"
      @keydown.shift.ctrl.enter="send(true)"
  >

    <v-menu
        slot="append-outer"
        transition="slide-y-transition"
        bottom
    >
      <template v-slot:activator="{ on }">
        <v-btn
            icon
            color="accent"
            v-on="on"
            :loading="loading"
            :disabled="loading"
        >
          <v-icon>mdi-send</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
            :loading="loading"
            :disabled="loading"
            @click.prevent="send()"
        >
          <v-list-item-icon>
            <v-icon color="accent">mdi-send</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Send</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text class="text--disabled"><sup>Ctrl<br>Enter</sup></v-list-item-action-text>
          </v-list-item-action>
        </v-list-item>
        <v-list-item
            :loading="loading"
            :disabled="loading"
            @click.prevent="send(true)"
            two-line
        >
          <v-list-item-icon>
            <v-icon color="red">mdi-send-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Send</v-list-item-title>
            <v-list-item-subtitle class="red--text">with response request</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text class="text--disabled"><sup>Shift<br>Ctrl<br>Enter</sup></v-list-item-action-text>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-textarea>
</template>
<script>
export default {
  name: 'MessagesInput',
  props: {
    value: Object,
    loading: Boolean,
    rows: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      message: this.value
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newValue) {
        this.message = newValue
      }
    },
    message: {
      deep: true,
      handler(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    send(requestResponse = false) {
      let newMessage = {
        body: this.message.body.replace(/^\s+|\s+$/g, ''),
        is_response_requested: requestResponse
      }
      this.$emit('send', newMessage)
    }
  }
}
</script>